import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "./styles/WantedSearchCarousel.css";
import * as actions from "../redux/actions/searchMissActions";

class WantedSearchEmpty extends React.Component {
  onAdd = async () => {
    const text = (this.props.query || "").trim();
    if (!text || !this.props.token) return;

    try {
      await this.props.AddSearchMiss(text, this.props.user_id, this.props.token);
      if (this.props.error) {
        alertify.warning(I18n.t(this.props.error));
      } else {
        alertify.success(I18n.t("search_miss_added"));
      }
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const text = (this.props.query || "").trim();
    if (!text) {
      return (
        <div className="wanted-search-empty">
          <h3 className="wanted-search-empty__title">
            <Translate value="ad_search_not_list" />
          </h3>
        </div>
      );
    }

    return (
      <div className="wanted-search-empty">
        <h3 className="wanted-search-empty__title">
          <Translate value="ad_search_not_list" />
        </h3>
        <p className="wanted-search-empty__query" title={text}>
          <strong>"{text}"</strong>
        </p>
        <button
          type="button"
          className="wanted-search-empty__btn"
          disabled={this.props.saving}
          onClick={this.onAdd}
        >
          <Translate value="search_miss_add" />
        </button>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    saving: reducer.searchMiss.saving,
    error: reducer.searchMiss.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  AddSearchMiss: (text, user_id, token) =>
    dispatch(actions.newItem({ text, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(WantedSearchEmpty);
